import React from "react";
import PropTypes from 'prop-types';
import { Translate, I18n } from "react-redux-i18n";
import Input from "components/Form/Input";

Form.propTypes = {
    handleSubmit: PropTypes.func.isRequired
};

export default function Form({ handleSubmit }) {
    return (
        <form className="form" onSubmit={ handleSubmit }>
            <Input
                label={ I18n.t("form.company-name") }
                name="companyName"
                type="text"
                required
            />
            <Input
                label={ I18n.t("form.company-website") }
                name="companyWebsite"
                type="text"
                required
            />
            <Input
                label={ I18n.t("form.located-country") }
                name="locatedCountry"
                type="text"
                required
            />
            <Input
                label={ I18n.t("form.located-city") }
                name="locatedCity"
                type="text"
                required
            />
            <Input
                label={ I18n.t("business-cooperation.business-opportunity") }
                name="businessOpportunity"
                placeholder={ I18n.t(
                    "business-cooperation.business-opportunity-placeholder"
                ) }
                type="textarea"
                required
            />
            <section className="contact-information-section">
                <Translate
                    className="contact-information"
                    value="business-cooperation.your-contact-information"
                    tag="h5"
                />
                <Input
                    label={ I18n.t("form.first-name") }
                    name="firstName"
                    type="text"
                    required
                />
                <Input
                    label={ I18n.t("form.last-name") }
                    name="lastName"
                    type="text"
                    required
                />
                <Input
                    label={ I18n.t("form.phone") }
                    name="phone"
                    placeholder={ I18n.t("form.phone-placeholder") }
                    type="tel"
                    required
                />
                <Input
                    label={ I18n.t("form.email") }
                    name="email"
                    type="email"
                    pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                    required
                />
            </section>
            <Input
                type="submit"
                className="btn btn-primary submit"
                value={ I18n.t("form.submit") }
            />
        </form>
    );
}
